import axios from 'axios';
import { t } from 'i18next';
import { endpoints } from '../../utils/constants';

const getOrderByBillNumber = (billNumber, accountNumbers) =>
  axios.get(`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.manageOrders.trackOrderByBillNumber}`, {
    params: { billNumber },
    headers: { accountNumbers },
  });

export default getOrderByBillNumber;
